// Copyright (c) 2024 Deere & Company

import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../shared/state/busy-counter';
import Facets, {getDefaultState as getFacetsDefaultState} from './facets';
import FactoryDuplicatePinPlates, {getDefaultState as getFactoryDuplicatePinPlatesDefaultState} from './factory-duplicate-pin-plate';
import SearchByDropDown, {getDefaultState as getSearchByDropDownDefaultState} from '../../shared/state/search-by-dropdown';
import SearchFilters, {getDefaultState as getSearchFiltersDefaultState} from './search-filters';
import t from 'tcomb';

const State = t.struct({
    busyCounter: BusyCounter,
    facets: Facets,
    factoryDuplicatePinPlates: FactoryDuplicatePinPlates,
    hasSearchResults: t.Boolean,
    searchByDropDown: SearchByDropDown,
    searchFilters: SearchFilters,
    searchQueryString: t.String
}, 'State');

export const getDefaultState = () =>
    new State({
        busyCounter: getBusyCounterDefaultState(),
        facets: getFacetsDefaultState(),
        factoryDuplicatePinPlates: getFactoryDuplicatePinPlatesDefaultState(),
        hasSearchResults: false,
        searchByDropDown: getSearchByDropDownDefaultState(),
        searchFilters: getSearchFiltersDefaultState(),
        searchQueryString: ''
    });

export default State;



// WEBPACK FOOTER //
// ./src/product/factory-users-duplicate-pin-plate/state/index.js